/* 130R · Kits por carro: PERGUNTAS GUIADAS (/pages/kits-por-carro?guia=). Agente kit-guia, 19/10/2026.
   Ideia do Marcus (19/10/2026): "uma serie de perguntas para facilitar que o cliente encontre o que ele precisa e na
   sequencia se nao encontrar ele já vai ser bem direcionado para o whatsapp". Tom de balcão: sem personagem, sem "adivinhar".
   PRIORIDADE (Marcus, 19/10/2026): "No final do dia a interação do cliente com o whatsapp é mais importante do que ele
   descobrir sozinho através das perguntas." Por isso: botão verde do WhatsApp em toda tela, com o resumo do que já foi
   respondido; "Não sei" lembra que o vendedor descobre pelo chassi; no resultado, a ação principal é "Confirmar com um
   vendedor"; e, nas perguntas, o WhatsApp da barra do celular (painel do chassi) manda o resumo.
   Número principal: kit_guia_whatsapp ÷ kit_guia_inicio, por "passo" (onde o clique aconteceu).

   COMO FUNCIONA
     - É um passo do localizador (assets/r130-kits.js): com &guia=<respostas> no endereço, o localizador chama
       R130KitsGuia.render(window.R130Kits) no lugar dos passos dele. O carro, o "Trocar o carro", os cartões dos kits
       (a mesma função grade/cartao), o carrinho e o voltar do navegador são os do localizador.
     - Começa pelo carro (o "Meu carro", se houver). Depois: o sintoma e o "onde" (nesta ordem, cada um só se dividir os
       kits), o conjunto (que peça) e, por último, a que mais divide entre abrangência (peça, lado, conjunto, completo),
       motor e marca. Pergunta que não tira kit nenhum é pulada. Para com até LIMITE kits ou MAX_PERGUNTAS respostas.
     - "Não sei" não corta nada. O sintoma NUNCA é diagnóstico: só tira o que é de outra parte do carro (filtro largo por
       sistema) e põe primeiro as peças que costumam estar ligadas a ele ("costuma estar ligado a…").
     - Endereço: &guia=sintoma.lombada-onde.frente-peca.nao_sei (respostas na ordem) e as marcas "-ver" (ver os kits
       agora) e "-wa" (tela do WhatsApp). Cada resposta é um passo do histórico.
     - Motor (decisão do Marcus, 19/10/2026: SÓ ORDENA, nunca corta, até o cadastro de aplicação ser revisto): o
       r130_garage.motor (do mesmo carro) ou a resposta da pergunta do motor põe primeiro os kits cuja aplicação bate
       com o motor (comparação tolerante: "2.0" = "2.0 16V"; kit sem motor na aplicação bate com qualquer um); os
       outros ficam abaixo, com "Confirme pelo chassi". A contagem não muda. A pergunta do motor só vem no fim, se ainda
       separar a lista. O guia NÃO grava o motor.

   DADOS (tools/site/kits_por_carro.py): o índice traz "guia" (grupos, onde, abrangencia, sintomas) e cada kit, "ab".
   GANCHOS: window.R130Kits (localizador), r130_garage, r130_chassi (o r130-chassi.js põe o chassi na linha "Chassi:"),
   [data-r130-chassi-abrir], window.R130Medicao.emitir, evento 'r130:kits-passo' (fim de cada passo do localizador).
   EVENTOS: kit_guia_inicio, kit_guia_pergunta, kit_guia_resultado, kit_guia_whatsapp, kit_guia_desistiu. */
(function () {
  'use strict';

  /* ======================= NÚCLEO (sem tela: o teste roda no node com os JSON de verdade) ======================= */
  var N = (function () {
    var LIMITE = 5;            // com até 5 kits, mostra o resultado
    var MAX_PERGUNTAS = 6;     // perguntas respondidas depois do carro
    var GANHO_MIN = 0.15;      // nas fases 2 e 3, a pergunta precisa tirar em média 15% dos kits
    var NAO_SEI = 'nao_sei';
    var MAX_OPCOES_ITEM = 8;   // "qual destas peças?" só com até 8 peças diferentes na lista
    var FASES = [['sintoma', 'onde'], ['peca'], ['item', 'ab', 'marca']];   // o motor não corta: vem no fim (proxima)
    var MOTOR_MIN = 0.15;      // a pergunta do motor só vem se pelo menos 15% dos kits ficariam abaixo
    var PERGUNTAS = ['sintoma', 'onde', 'peca', 'item', 'ab', 'motor', 'marca'];
    // Textos do Marcus (19/10/2026).
    var MARCAS = [{ id: 'mobis', nome: 'Mobis', ajuda: 'Peça genuína Hyundai e Kia' },
      { id: 'hs', nome: 'HS Parts', ajuda: 'Fabricada na Coreia, padrão da original, preço menor' }];

    function uniq(l) { var o = []; l.forEach(function (x) { if (x != null && x !== '' && o.indexOf(x) === -1) o.push(x); }); return o; }
    function inter(a, b) { return (a || []).some(function (x) { return (b || []).indexOf(x) !== -1; }); }
    function achar(l, id) { return (l || []).filter(function (x) { return x.id === id; })[0] || null; }

    function config(indice) {
      var g = indice && indice.guia;
      if (!g || !g.grupos || !g.sintomas) return null;
      var cfg = { grupos: g.grupos, onde: g.onde || [], ab: g.abrangencia || [], sintomas: g.sintomas, grupoDoTopico: {} };
      cfg.grupos.forEach(function (x) { (x.topicos || []).forEach(function (t) { cfg.grupoDoTopico[t] = x.id; }); });
      return cfg;
    }

    // Motor: "2.0" = "2.0 16V" = "2,0" (a cilindrada manda); sem número, o começo do texto.
    // "Elétrico" (rótulo do catálogo de motores do site) = "EV"/"EV400" (como a aplicação cadastra).
    function normMotor(m) {
      var t = String(m || '').trim();
      if (/^(el[eé]tric|ev)/i.test(t)) return 'EV';
      return t.toUpperCase().replace(/[^A-Z0-9.]/g, '');
    }
    function cilindrada(m) { var r = /(\d)\s*[.,]\s*(\d)/.exec(String(m || '')); return r ? r[1] + '.' + r[2] : ''; }
    function mesmoMotor(a, b) {
      var ca = cilindrada(a), cb = cilindrada(b);
      if (ca && cb) return ca === cb;
      var na = normMotor(a), nb = normMotor(b);
      return !!na && !!nb && (na.indexOf(nb) === 0 || nb.indexOf(na) === 0);
    }
    function motoresDoTexto(t) { return uniq(String(t || '').split(/,|\s+e\s+|\//).map(function (x) { return x.trim(); })); }
    function idMotor(m) { return normMotor(m).slice(0, 20); }
    // Peça do kit pelo nome do catálogo, sem o lado: "Bucha do braço (esquerdo)" → "Bucha do braço".
    function nomeItem(n) { return String(n || '').replace(/\s*\((esquerdo|direito|esquerda|direita)\)\s*$/i, '').trim(); }
    function idItem(n) {
      return String(n || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '').slice(0, 40);
    }

    function abPelaRegra(k, cfg) {   // JSON sem "ab" (gerador antigo): a regra do gerador, sem o nome das peças
      if (/^(P|Q)-/i.test(k.id || '') || (k.c || []).length <= 1) return 'peca';
      if (k.c.every(function (c) { return +c[1] === 1; })) return 'lado';
      var g = uniq((k.tp || []).map(function (t) { return cfg.grupoDoTopico[t] || 'outros'; }));
      if (g.length > 1) g = g.filter(function (x) { return x !== 'outros'; });
      return g.length > 1 ? 'completo' : 'conjunto';
    }

    // O que o guia precisa saber de um kit do carro: x = {k, d, faixas: [[ano_ini, ano_fim, motores]]} (kitsDoCarro).
    function perfil(x, ano, cfg) {
      if (x._kg) return x._kg;
      var k = x.k, pecas = (x.d && x.d.pecas) || {};
      var tp = k.tp && k.tp.length ? k.tp : [k.t];
      var grupos = uniq(tp.map(function (t) { return cfg.grupoDoTopico[t] || 'outros'; }));
      if (grupos.length > 1) grupos = grupos.filter(function (g) { return g !== 'outros'; });
      var marcas = uniq((k.c || []).map(function (c) { return (pecas[c[0]] || [])[2] || null; }));
      var mobis = marcas.indexOf('Mobis') !== -1, hs = marcas.indexOf('HS Parts') !== -1;
      var motores = [], livre = false;
      (x.faixas || []).forEach(function (r) {
        if (ano && (r[0] > ano || r[1] < ano)) return;
        var ms = motoresDoTexto(r[2]);
        if (!ms.length) livre = true; else motores = uniq(motores.concat(ms));
      });
      var nomes = [], fotos = [];   // peças do kit pelo nome (sem o lado) e a foto do anúncio do próprio código
      (k.c || []).forEach(function (c) {
        var pc = pecas[c[0]] || [], nm = nomeItem(pc[0]), i = nomes.indexOf(nm);
        if (!nm || nm === 'Peça') return;
        if (i === -1) { nomes.push(nm); fotos.push(pc[3] || ''); } else if (!fotos[i] && pc[3]) fotos[i] = pc[3];
      });
      x._kg = { s: k.s || [], tp: tp, grupos: grupos, ab: k.ab || abPelaRegra(k, cfg), itens: nomes.map(idItem), nomes: nomes, fotos: fotos,
        marca: mobis && !hs ? 'mobis' : hs && !mobis ? 'hs' : mobis ? 'misto' : 'outra',
        motores: livre || !motores.length ? null : motores };
      return x._kg;
    }

    // A resposta v à pergunta q mantém o kit? "Não sei" e resposta desconhecida mantêm tudo.
    function casa(q, v, p, cfg) {
      if (v === NAO_SEI) return true;
      if (q === 'sintoma') { var s = achar(cfg.sintomas, v); return !s || !(s.sistemas || []).length || inter(p.s, s.sistemas); }
      if (q === 'onde') { var o = achar(cfg.onde, v); return !o || inter(p.s, o.sistemas); }
      if (q === 'peca') return !achar(cfg.grupos, v) || p.grupos.indexOf(v) !== -1;
      if (q === 'ab') return !achar(cfg.ab, v) || p.ab === v;
      if (q === 'item') return p.itens.indexOf(v) !== -1;
      if (q === 'motor') return bateMotor(p, v);   // só para contar e ordenar: calcular() nunca corta pelo motor
      if (q === 'marca') return v === 'mobis' ? p.marca !== 'hs' : v === 'hs' ? p.marca !== 'mobis' : true;
      return true;
    }

    function sintomaDe(respostas, cfg) {
      var r = (respostas || []).filter(function (x) { return x.q === 'sintoma' && x.v !== NAO_SEI; })[0];
      return r ? achar(cfg.sintomas, r.v) : null;
    }
    function ligado(p, sint) { return !!(sint && (sint.topicos || []).length && inter(p.tp, sint.topicos)); }

    // Opções da pergunta, com quantos kits cada uma mantém (só as que mantêm algum).
    function opcoes(q, itens, cfg, ano, respostas) {
      var base = [];
      if (q === 'sintoma') base = cfg.sintomas.map(function (s) { return { id: s.id, nome: s.nome, ajuda: '' }; });
      else if (q === 'onde') base = cfg.onde.map(function (o) { return { id: o.id, nome: o.nome, ajuda: o.ajuda || '' }; });
      else if (q === 'ab') base = cfg.ab.map(function (a) { return { id: a.id, nome: a.nome, ajuda: a.ajuda || '' }; });
      else if (q === 'marca') base = MARCAS.map(function (m) { return { id: m.id, nome: m.nome, ajuda: m.ajuda }; });
      else if (q === 'peca') {
        var sint = sintomaDe(respostas, cfg), tops = sint ? sint.topicos || [] : [];
        base = cfg.grupos.map(function (g, i) {
          var pos = tops.length ? Math.min.apply(null, (g.topicos || []).map(function (t) { var j = tops.indexOf(t); return j === -1 ? 999 : j; }).concat([999])) : 999;
          return { id: g.id, nome: g.nome, ajuda: g.ajuda || '', liga: pos < 999, ordem: pos * 100 + i };
        }).sort(function (a, b) { return a.ordem - b.ordem; });
      } else if (q === 'item') {
        var cont = {}, nome = {}, foto = {};
        itens.forEach(function (x) {
          var p = perfil(x, ano, cfg);
          p.itens.forEach(function (id, i) { cont[id] = (cont[id] || 0) + 1; nome[id] = nome[id] || p.nomes[i]; foto[id] = foto[id] || p.fotos[i]; });
        });
        base = Object.keys(cont).sort(function (a, b) { return cont[b] - cont[a] || (nome[a] < nome[b] ? -1 : 1); })
          .map(function (id) { return { id: id, nome: nome[id], ajuda: '', foto: foto[id] || '' }; });
      } else if (q === 'motor') {
        var ms = [];
        itens.forEach(function (x) {
          (perfil(x, ano, cfg).motores || []).forEach(function (m) { if (!ms.some(function (y) { return mesmoMotor(y, m); })) ms.push(m); });
        });
        base = ms.sort(function (a, b) { return (parseFloat(cilindrada(a)) || 99) - (parseFloat(cilindrada(b)) || 99) || (a < b ? -1 : 1); })
          .map(function (m) { return { id: idMotor(m), nome: m, ajuda: '' }; });
      }
      return base.map(function (o) {
        var com = itens.filter(function (x) { return casa(q, o.id, perfil(x, ano, cfg), cfg); });
        o.n = com.length;
        if (q === 'ab' && com.length) o.exemplo = com[0].k.n;   // "Ex.: Par de bieletas": um kit de verdade que sobrou
        return o;
      }).filter(function (o) { return o.n > 0; });
    }

    // A pergunta divide os kits? Devolve as opções e o tamanho esperado do que sobra (menor = melhor), ou null.
    function avaliar(q, itens, cfg, ano, respostas) {
      var ops = opcoes(q, itens, cfg, ano, respostas), n = itens.length;
      if (ops.length < 2 || (q === 'item' && ops.length > MAX_OPCOES_ITEM)) return null;
      if (q !== 'sintoma' && !ops.some(function (o) { return o.n < n; })) return null;   // nenhuma resposta tira kit
      var soma = 0, quad = 0;
      ops.forEach(function (o) { soma += o.n; quad += o.n * o.n; });
      var esperado = quad / soma;
      return { q: q, opcoes: ops, esperado: esperado, ganho: (n - esperado) / n };
    }

    // A próxima pergunta, ou null (hora do resultado).
    function proxima(itens, respostas, cfg, ano) {
      var feitas = respostas.filter(function (r) { return !r.auto; }).length;
      if (itens.length <= LIMITE || feitas >= MAX_PERGUNTAS) return null;
      var ja = {};
      respostas.forEach(function (r) { ja[r.q] = 1; });
      for (var f = 0; f < FASES.length; f++) {
        var cand = FASES[f].filter(function (q) { return !ja[q]; })
          .map(function (q) { return avaliar(q, itens, cfg, ano, respostas); }).filter(Boolean);
        if (f === 0) { if (cand.length) return cand[0]; continue; }   // fase 1: o sintoma e depois o "onde"
        cand = cand.filter(function (c) { return c.ganho >= GANHO_MIN; }).sort(function (a, b) { return a.esperado - b.esperado; });
        if (cand.length) return cand[0];
      }
      return ja.motor ? null : avaliarMotor(itens, cfg, ano, respostas);
    }
    // A pergunta do motor só ORDENA: vem se houver 2 motores ou mais e se alguma resposta deixaria pelo menos 15% dos kits
    // abaixo (com "Confirme pelo chassi") e algum acima.
    function avaliarMotor(itens, cfg, ano, respostas) {
      var ops = opcoes('motor', itens, cfg, ano, respostas), n = itens.length;
      if (ops.length < 2) return null;
      if (!ops.some(function (o) { return o.n >= 1 && (n - o.n) >= Math.max(1, MOTOR_MIN * n); })) return null;
      return { q: 'motor', opcoes: ops, esperado: n, ganho: 0, ordena: true };
    }
    function bateMotor(p, m) { return !m || m === NAO_SEI || !p.motores || p.motores.some(function (x) { return mesmoMotor(x, m); }); }
    function motorDe(respostas) {
      var r = (respostas || []).filter(function (x) { return x.q === 'motor' && x.v !== NAO_SEI; })[0];
      return r ? r.v : '';
    }

    // Aplica as respostas na ordem. Resposta que zeraria a lista (endereço velho) é ignorada.
    function calcular(itens, respostas, cfg, ano) {
      var atual = itens, passos = [];
      respostas.forEach(function (r) {
        if (r.q === 'motor') { r.ignorada = false; passos.push({ q: r.q, v: r.v, antes: atual.length, depois: atual.length }); return; }
        var novo = atual.filter(function (x) { return casa(r.q, r.v, perfil(x, ano, cfg), cfg); });
        r.ignorada = !novo.length;
        passos.push({ q: r.q, v: r.v, antes: atual.length, depois: novo.length || atual.length });
        if (novo.length) atual = novo;
      });
      return { itens: atual, passos: passos };
    }

    function compravel(k) { return (k.a || []).some(function (a) { return a[3]; }) ? 1 : 0; }
    // Ordem do resultado: primeiro os do motor do cliente (se ele disse o motor), depois o que costuma estar ligado ao
    // sintoma, em estoque, à venda e mais vendido.
    function ordenar(itens, respostas, cfg, ano) {
      var sint = sintomaDe(respostas, cfg), m = motorDe(respostas);
      return itens.map(function (x, i) {
        var p = perfil(x, ano, cfg);
        return [bateMotor(p, m) ? 0 : 1, ligado(p, sint) ? 0 : 1, i, x];
      }).sort(function (a, b) {
        var x = a[3].k, y = b[3].k;
        return a[0] - b[0] || a[1] - b[1] || (y.e - x.e) || (compravel(y) - compravel(x)) || ((y.o || 0) - (x.o || 0)) || a[2] - b[2];
      }).map(function (a) { return a[3]; });
    }

    // Respostas no endereço: "sintoma.lombada-onde.frente-peca.nao_sei-ver-wa".
    function ler(txt) {
      var r = { lista: [], ver: false, wa: false }, vistas = {};
      String(txt || '').split('-').forEach(function (tok) {
        if (tok === 'ver') { r.ver = true; return; }
        if (tok === 'wa' || tok === 'wac' || tok === 'war') { r.wa = true; r.waCtx = { wa: '', wac: 'confirmar', war: 'resultado' }[tok]; return; }
        var i = tok.indexOf('.');
        if (i < 1) return;
        var q = tok.slice(0, i), v = tok.slice(i + 1);
        if (PERGUNTAS.indexOf(q) === -1 || !/^[A-Za-z0-9_.]{1,40}$/.test(v) || vistas[q]) return;
        vistas[q] = 1;
        r.lista.push({ q: q, v: v });
      });
      return r;
    }
    function escrever(lista, marcas) {
      return lista.filter(function (r) { return !r.auto; }).map(function (r) { return r.q + '.' + r.v; })
        .concat(marcas || []).join('-');
    }

    return { LIMITE: LIMITE, MAX_PERGUNTAS: MAX_PERGUNTAS, NAO_SEI: NAO_SEI, PERGUNTAS: PERGUNTAS, config: config,
      perfil: perfil, casa: casa, opcoes: opcoes, avaliar: avaliar, proxima: proxima, calcular: calcular, ordenar: ordenar,
      sintomaDe: sintomaDe, ligado: ligado, ler: ler, escrever: escrever, mesmoMotor: mesmoMotor, idMotor: idMotor,
      motoresDoTexto: motoresDoTexto, compravel: compravel, achar: achar, nomeItem: nomeItem, idItem: idItem,
      bateMotor: bateMotor, motorDe: motorDe };
  })();

  if (typeof window === 'undefined') {   // node: o teste usa só o núcleo
    if (typeof module === 'object' && module.exports) module.exports = N;
    return;
  }

  /* ======================= TELA ======================= */
  var FONE = '5511910801297';
  var SECAO = 'kits_guia';
  var POR_PAGINA = 24;
  var api = null;
  var cfgDoIndice = null, cfg = null;
  var sessao = null;          // uma ida às perguntas: {entrada, concluiu, fechada, ultima, perguntas, kits, resultados: {}}
  var comoSair = '', ultimoPop = 0, mostrar = POR_PAGINA, telaAtual = null;

  var ROTULO = { sintoma: 'O que acontece', onde: 'Onde', peca: 'Conjunto', item: 'Peça', ab: 'O que levar', motor: 'Motor', marca: 'Marca' };
  var mapaItens = {};         // id da peça → nome (para o resumo e a mensagem)
  var NAO_SEI_TXT = { sintoma: 'Outro problema ou não sei dizer', marca: 'Tanto faz' };
  var ONDE_FRASE = { frente: 'da suspensão da frente', tras: 'da suspensão de trás', motor: 'do motor ou do câmbio',
    freio: 'do freio', direcao: 'da direção', arrefecimento: 'do arrefecimento', carroceria: 'da lataria e do acabamento' };
  var ICONES = {
    sintoma: { lombada: 'amortecedor', volante: 'carro', puxando: 'carro', balanca: 'amortecedor', motor_vibra: 'coxim',
      oleo: 'coxim', freio: 'freio', agua: 'arrefecimento', lataria: 'acabamento', revisao: 'check' },
    onde: { frente: 'amortecedor', tras: 'bucha', motor: 'coxim', freio: 'freio', direcao: 'carro', arrefecimento: 'arrefecimento',
      carroceria: 'acabamento' },
    peca: { amortecedor: 'amortecedor', bandeja: 'bucha', barra: 'bieleta', bracos: 'bieleta', buchas_estrutura: 'bucha',
      direcao: 'carro', coxins_motor: 'coxim', vedacao: 'coxim', transmissao: 'coxim', pastilhas: 'freio', discos: 'freio',
      arrefecimento: 'arrefecimento', roda: 'kit', outros: 'kit' },
    ab: { lado: 'bucha', peca: 'caixa', conjunto: 'kit', completo: 'kit' },
    marca: { mobis: 'selo', hs: 'selo' }
  };

  function iconeItem(n) {
    n = String(n || '').toLowerCase();
    return /coxim/.test(n) ? 'coxim' : /batente|coifa/.test(n) ? 'batente' : /rolamento|amortecedor|calço|mola|prato/.test(n) ? 'amortecedor'
      : /bieleta|pivô|braço|bandeja|terminal/.test(n) ? 'bieleta' : /bucha/.test(n) ? 'bucha' : /pastilha|disco/.test(n) ? 'freio'
      : /mangueira|radiador|flange/.test(n) ? 'arrefecimento' : 'kit';
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; }); }
  function plural(n, um, varios) { return n + ' ' + (n === 1 ? um : varios); }
  function chave(s) { return String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  function ico(nome) {
    var t = document.querySelector('template[data-kguia-ico="' + nome + '"]');
    return t ? t.innerHTML : (api && api.ico ? api.ico(nome) : '');
  }
  function lsJson(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function linkWa(texto) { return 'https://wa.me/' + FONE + '?text=' + encodeURIComponent(texto); }
  function emitir(nome, campos) {
    try {
      if (window.R130Medicao && typeof window.R130Medicao.emitir === 'function') {
        window.R130Medicao.emitir(nome, Object.assign({ origem: 'pagina/' + SECAO, secao: SECAO }, campos || {}));
      }
    } catch (e) {}
  }
  function cfgDe(indice) {
    if (indice !== cfgDoIndice) { cfgDoIndice = indice; cfg = N.config(indice); }
    return cfg;
  }
  function disponivel(indice) { return !!cfgDe(indice); }

  /* ---------- carro, motor e respostas ---------- */
  function nomeCarro(c, comMontadora) { return api && c ? api.nomeCarro(c, comMontadora) : ''; }
  function motorDaGaragem(c) {   // r130_garage.motor, só se for o mesmo carro da tela (contrato com o agente veiculo-motor)
    var g = lsJson('r130_garage');
    if (!g || !g.motor || !c) return '';
    if (chave(g.brand) !== chave(c.m) || chave(g.model) !== c.md) return '';
    if (g.year && c.a && Number(g.year) !== c.a) return '';
    return String(g.motor).trim().slice(0, 30);
  }
  function respostasDaTela() {
    var e = api.estado(), r = N.ler(e.guia);
    var mg = motorDaGaragem(e.carro);
    if (mg && !r.lista.some(function (x) { return x.q === 'motor'; })) r.lista.unshift({ q: 'motor', v: N.idMotor(mg) || 'X', auto: true, nome: mg });
    return r;
  }
  function textoResposta(r) {
    if (r.v === N.NAO_SEI) return NAO_SEI_TXT[r.q] || 'Não sei';
    if (r.q === 'motor') return r.nome || r.vNome || r.v;
    if (r.q === 'item') return mapaItens[r.v] || r.v.replace(/_/g, ' ');
    var l = r.q === 'sintoma' ? cfg.sintomas : r.q === 'onde' ? cfg.onde : r.q === 'peca' ? cfg.grupos : r.q === 'ab' ? cfg.ab : null;
    var o = l ? N.achar(l, r.v) : r.q === 'marca' ? { mobis: { nome: 'Mobis' }, hs: { nome: 'HS Parts' } }[r.v] : null;
    return o ? o.nome : r.v;
  }
  function motorConhecido(lista) {
    var m = lista.filter(function (r) { return r.q === 'motor' && r.v !== N.NAO_SEI; })[0];
    return m ? (m.nome || m.vNome || m.v) : '';
  }
  function ir(lista, marcas, extra) {
    mostrar = POR_PAGINA;
    api.ir(Object.assign({ guia: N.escrever(lista, marcas), s: null, t: null, q: '' }, extra || {}));
  }

  /* ---------- sessão e eventos ---------- */
  function abrirSessao(entrada) {
    if (sessao && !sessao.fechada) return false;
    sessao = { entrada: entrada || 'link', concluiu: false, fechada: false, ultima: '', perguntas: 0, kits: '', resultados: {} };
    return true;
  }
  function camposCarro() {
    var e = api ? api.estado() : {}, c = e.carro, m = c && api.montadora(c.m), md = c && api.modelo(c.m, c.md);
    return { montadora: m ? m.nome : '', modelo: md ? md.nome : '', ano: c && c.a ? c.a : '', origem_carro: e.origemCarro || '' };
  }
  function fecharSessao(passo) {
    if (!sessao || sessao.fechada) return;
    sessao.fechada = true;
    if (sessao.concluiu) return;
    var como = comoSair || (Date.now() - ultimoPop < 2000 ? 'voltar' : passo === 'busca' ? 'busca' : 'localizador');
    comoSair = '';
    emitir('kit_guia_desistiu', Object.assign(camposCarro(), camposSessao(), { como: como, na_pergunta: sessao.ultima || 'carro',
      perguntas: sessao.perguntas, kits: sessao.kits }));
  }
  // Entrada e sintoma da ida: para medir se o sintoma ajuda (resultado e WhatsApp por sintoma; "nao_sei" na pergunta 1).
  function camposSessao() {
    return { entrada: sessao ? sessao.entrada : '', sintoma: sessao ? sessao.sintoma || '' : '' };
  }

  /* ---------- telas ---------- */
  function opcaoHtml(q, o, extra) {
    var nao = o.id === N.NAO_SEI;
    // "Qual destas peças?": a foto do anúncio da própria peça ajuda quem não sabe o nome (o nome vai no texto do botão).
    var foto = o.foto && api && api.urlImg ? api.urlImg(o.foto, 96) : '';
    return '<li><button type="button" class="r130-kits__opcao' + (nao ? ' r130-kits-guia__naosei' : '') + (o.liga ? ' r130-kits-guia__opcao--liga' : '')
      + '" data-kguia="responder" data-q="' + esc(q) + '" data-v="' + esc(o.id) + '" data-n="' + o.n + '">'
      + (foto ? '<span class="r130-kits__opcao-ico r130-kits-guia__opcao-foto" aria-hidden="true"><img src="' + esc(foto)
        + '" alt="" width="48" height="48" loading="lazy" decoding="async"></span>'
        : '<span class="r130-kits__opcao-ico" aria-hidden="true">' + (nao ? '' : ico(q === 'item' ? iconeItem(o.nome)
        : (ICONES[q] || {})[o.id] || (q === 'motor' ? 'carro' : q === 'peca' ? 'acabamento' : 'kit'))) + '</span>')
      + '<span class="r130-kits__opcao-txt"><span class="r130-kits__opcao-nome">' + esc(o.nome) + '</span>'
      + (o.ajuda || o.exemplo ? '<span class="r130-kits-guia__ajuda">' + esc((o.ajuda ? o.ajuda + '. ' : '') + (o.exemplo ? 'Ex.: ' + o.exemplo : '')).replace(/\. $/, '') + '</span>' : '')
      + '<span class="r130-kits__opcao-n">' + esc(extra || plural(o.n, 'kit', 'kits')) + '</span>'
      + (o.liga ? '<span class="r130-kits-guia__liga">Costuma estar ligado ao problema</span>' : '') + '</span>'
      + '<span class="r130-kits__opcao-chev" aria-hidden="true">' + ico('seta') + '</span></button></li>';
  }
  function titulo(q, lista, c) {
    var md = c ? (api.modelo(c.m, c.md) || {}).nome : '';
    if (q === 'sintoma') return 'O que está acontecendo com o ' + (md || 'carro') + '?';
    if (q === 'onde') return 'Onde fica o problema?';
    if (q === 'peca') {
      var o = lista.filter(function (r) { return r.q === 'onde' && r.v !== N.NAO_SEI; })[0];
      return o && ONDE_FRASE[o.v] ? 'Que peça ' + ONDE_FRASE[o.v] + ' você vai trocar?' : 'Que peça ou conjunto você vai trocar?';
    }
    if (q === 'ab') return 'O que você quer levar?';
    if (q === 'item') return 'Qual destas peças você precisa?';
    if (q === 'motor') return 'Qual é o motor do seu ' + (md || 'carro') + '?';
    return 'Tem preferência de marca?';
  }
  function intro(q, lista) {
    var sint = N.sintomaDe(lista, cfg);
    if (q === 'sintoma') return 'Escolha o que mais parece. Isso só ajuda a mostrar primeiro as peças que costumam estar ligadas ao problema: quem confirma a causa é o mecânico.';
    if (q === 'onde') return 'Escolha a parte do carro. Na dúvida, toque em “Não sei”.';
    if (q === 'peca') return sint && sint.liga ? 'Para “' + sint.nome.toLowerCase() + '”, as peças que costumam estar ligadas vêm primeiro, marcadas. Confirme com o mecânico ou pelo chassi.'
      : 'Não sabe o nome? Toque em “Não sei”: as próximas perguntas ajudam.';
    if (q === 'ab') return 'Só uma peça, um lado do carro ou o reparo completo.';
    if (q === 'item') return 'Se precisar de mais de uma, escolha qualquer uma: os kits com várias peças continuam na lista. Na dúvida, toque em “Não sei”.';
    if (q === 'motor') return 'Os kits do seu motor vêm primeiro; os outros continuam na lista, para confirmar pelo chassi. Na dúvida, toque em “Não sei”.';
    return 'Alguns kits existem em mais de uma marca.';
  }
  function linhaConta(n, total) {   // o motor não entra: ele só ordena (decisão do Marcus, 19/10/2026)
    return '<p class="r130-kits-guia__conta" role="status" aria-live="polite">'
      + (n === total ? '<strong>' + plural(total, 'kit cadastrado', 'kits cadastrados') + '</strong> para este carro'
        : 'Restam <strong>' + n + '</strong> dos ' + plural(total, 'kit cadastrado', 'kits cadastrados') + ' para este carro') + '</p>';
  }
  function botaoVoltar(lista, r) {
    var tem = lista.some(function (x) { return !x.auto; }) || r.ver;
    return tem ? '<button type="button" class="r130-kits__voltar" data-kguia="voltar">' + ico('voltar') + 'Voltar uma pergunta</button>'
      : '<button type="button" class="r130-kits__voltar" data-kguia="sair">' + ico('voltar') + 'Sair das perguntas</button>';
  }

  // Bloco do vendedor (prioridade do Marcus): botão verde que já abre o WhatsApp com a mensagem pronta (o r130-chassi.js
  // põe o chassi no clique) e o link "Ver ou mudar a mensagem", que abre a tela com o texto editável.
  function blocoWhats(o) {
    var msg = mensagem(o.lista, o.itens, o.c, o.contexto);
    return '<div class="r130-kits-guia__vend' + (o.classe ? ' ' + o.classe : '') + '">'
      + '<a class="r130-btn r130-btn--wa r130-kits-guia__vend-btn" target="_blank" rel="noopener" data-kguia-wa="' + esc(o.passo)
      + '" data-kguia-ctx="' + esc(o.contexto) + '" href="' + esc(linkWa(msg)) + '">' + ico('whatsapp') + '<span>' + esc(o.texto) + '</span></a>'
      + '<p class="r130-kits-guia__vend-leg">' + esc(o.legenda) + ' <button type="button" class="r130-kits__linkbtn r130-kits-guia__linkna"'
      + ' data-kguia="vendedor" data-ctx="' + esc(o.contexto) + '">Ver ou mudar a mensagem</button></p></div>';
  }
  function naoSeiAntes(lista) {
    var feitas = lista.filter(function (x) { return !x.auto; });
    return !!feitas.length && feitas[feitas.length - 1].v === N.NAO_SEI;
  }
  // Painel do chassi (o WhatsApp da barra do celular e o do topo abrem ele): nas perguntas, a mensagem dele vira o resumo
  // das respostas (atributo data-msg, que o r130-chassi.js lê no envio e completa com o chassi). Fora delas, a original.
  var painelMsgOriginal = null;
  function msgDoPainel(texto) {
    var dlg = document.getElementById('r130-chassi');
    if (!dlg) return;
    if (painelMsgOriginal === null) {
      if (texto == null) return;
      painelMsgOriginal = dlg.getAttribute('data-msg') || '';
    }
    dlg.setAttribute('data-msg', texto == null ? painelMsgOriginal : String(texto).replace(/\nChassi:\s*$/, ''));
  }

  function telaPergunta(px, calc, total, r, lista, c) {
    var q = px.q, n = calc.itens.length, num = lista.filter(function (x) { return !x.auto; }).length + 1;
    var ops = px.opcoes;
    var h = '<div class="r130-kits-guia" data-kguia-tela="pergunta" data-kguia-q="' + q + '">'
      + botaoVoltar(lista, r)
      + '<div class="r130-kits-guia__topo"><p class="r130-kits-guia__passo">Pergunta ' + num + '</p>' + linhaConta(n, total) + '</div>'
      + '<h2 class="r130-kits__h2" data-kits-foco tabindex="-1">' + esc(titulo(q, lista, c)) + '</h2>'
      + '<p class="r130-kits__intro">' + esc(intro(q, lista)) + '</p>'
      + blocoWhats({ lista: lista, itens: N.ordenar(calc.itens, lista, cfg, c.a), c: c, contexto: 'vendedor', passo: 'pergunta_' + q,
        texto: 'Falar com um vendedor', legenda: naoSeiAntes(lista) ? 'Não soube responder? Um vendedor descobre pelo chassi.'
          : 'Ele recebe o que você já respondeu.', classe: naoSeiAntes(lista) ? 'r130-kits-guia__vend--naosei' : '' })
      + '<ul class="r130-kits__opcoes r130-kits-guia__opcoes" role="list">'
      + ops.map(function (o) { return opcaoHtml(q, o, q === 'motor' ? (o.n === 1 ? '1 kit vem primeiro' : o.n + ' kits vêm primeiro') : undefined); }).join('')
      + opcaoHtml(q, { id: N.NAO_SEI, nome: NAO_SEI_TXT[q] || 'Não sei', n: n }, 'Continua com ' + plural(n, 'kit', 'kits'))
      + '</ul>'
      + '<div class="r130-kits-guia__acoes">'
      + '<button type="button" class="r130-btn r130-btn--ghost" data-kguia="ver">Ver ' + (n === 1 ? 'o kit' : 'os ' + n + ' kits') + ' agora</button>'
      + '</div>';
    if (num === 1) {
      h += '<form class="r130-kits-guia__codigo" data-kguia-codigo action="#" novalidate>'
        + '<label class="r130-kits-guia__codigo-rot" for="r130-kguia-cod">Já tem a lista ou o código que o mecânico passou?</label>'
        + '<div class="r130-kits__busca-linha"><input class="r130-kits__busca-campo" id="r130-kguia-cod" name="cod" type="search" autocomplete="off"'
        + ' enterkeyhint="search" maxlength="80" placeholder="Ex.: 54830-2E000 ou bieleta">'
        + '<button class="r130-btn r130-btn--ink r130-kits__busca-btn" type="submit">' + ico('busca') + '<span>Buscar</span></button></div></form>';
    } else {
      h += '<p class="r130-kits-guia__sair"><button type="button" class="r130-kits__linkbtn" data-kguia="sair">Sair das perguntas</button></p>';
    }
    h += '</div>';
    api.painel.innerHTML = h;
    msgDoPainel(mensagem(lista, N.ordenar(calc.itens, lista, cfg, c.a), c, 'vendedor'));
    sessao.ultima = q; sessao.perguntas = num - 1; sessao.kits = n;
    telaAtual = { tela: 'pergunta', q: q, n: n, lista: lista, r: r };
  }

  function caixaRespostas(lista) {
    var itens = lista.filter(function (x) { return !x.ignorada; });
    if (!itens.length) return '';
    return '<div class="r130-kits-guia__respostas"><p class="r130-kits-guia__respostas-tit">Suas respostas</p><ul>'
      + itens.map(function (x) {
        return '<li><span class="r130-kits-guia__respostas-q">' + esc(ROTULO[x.q] || x.q) + ':</span> ' + esc(textoResposta(x))
          + (x.auto ? ' <span class="r130-kits-guia__respostas-obs">(do Meu carro)</span>' : '') + '</li>';
      }).join('') + '</ul>'
      + '<button type="button" class="r130-kits__linkbtn" data-kguia="refazer">Refazer as perguntas</button></div>';
  }
  function notaSintoma(lista) {
    var s = N.sintomaDe(lista, cfg);
    if (!s || !s.liga) return '';
    return '<div class="r130-kits-guia__nota">' + ico('alerta') + '<p><strong>“' + esc(s.nome) + '”</strong> costuma estar ligado a '
      + esc(s.liga) + '. ' + (s.nota ? esc(s.nota) + ' ' : '') + 'Isso não é diagnóstico: confirme com o mecânico ou pelo chassi antes de comprar.</p></div>';
  }

  function telaResultado(calc, total, r, lista, c, via) {
    var itens = N.ordenar(calc.itens, lista, cfg, c.a), n = itens.length;
    var semResposta = !lista.some(function (x) { return !x.auto && !x.ignorada; });
    var est = itens.filter(function (x) { return x.k.e; }).length, site = itens.filter(function (x) { return x.k.a && x.k.a.length; }).length;
    var vis = itens.slice(0, mostrar);
    // Motor (só ordena): os que batem vêm primeiro; os outros, abaixo do divisor, com "Confirme pelo chassi".
    var motor = N.motorDe(lista), auto = lista.filter(function (x) { return x.auto; })[0];
    var nomeMotor = motor ? motorConhecido(lista) : '';
    var bate = function (x) { return N.bateMotor(N.perfil(x, c.a, cfg), motor); };
    var abaixo = itens.filter(function (x) { return !bate(x); });
    var visAcima = vis.filter(bate), visAbaixo = vis.filter(function (x) { return !bate(x); });
    var notaMotor = motor ? '<div class="r130-kits-guia__nota r130-kits-guia__nota--motor">' + ico('carro') + '<p><strong>Motor ' + esc(nomeMotor) + '</strong>'
      + (auto ? ' (do Meu carro)' : '') + ': ' + (abaixo.length ? 'os kits com esse motor na aplicação vêm primeiro. ' + plural(abaixo.length, 'kit', 'kits')
        + ' com outro motor na aplicação ' + (abaixo.length === 1 ? 'continua' : 'continuam') + ' na lista, mais abaixo: confirme pelo chassi.'
        : 'todos os kits desta lista têm esse motor (ou qualquer motor) na aplicação.') + '</p></div>' : '';
    var h = '<div class="r130-kits-guia" data-kguia-tela="resultado">' + botaoVoltar(lista, r)
      + '<h2 class="r130-kits__h2" data-kits-foco tabindex="-1">'
      + esc(semResposta ? 'Os ' + plural(n, 'kit cadastrado', 'kits cadastrados') + ' para o ' + nomeCarro(c)
        : (n === 1 ? '1 kit combina' : n + ' kits combinam') + ' com as suas respostas') + '</h2>'
      + '<p class="r130-kits__resumo" role="status">' + esc(nomeCarro(c, true) + ' · ' + est + ' em estoque · ' + site + ' à venda no site') + '</p>'
      + blocoWhats({ lista: lista, itens: itens, c: c, contexto: 'confirmar', passo: 'resultado_topo', classe: 'r130-kits-guia__vend--principal',
        texto: n <= 5 ? 'Mandar ' + (n === 1 ? 'este kit' : 'estes kits') + ' para um vendedor confirmar' : 'Confirmar com um vendedor no WhatsApp',
        legenda: 'Ele recebe o carro, as suas respostas e ' + (n <= 5 ? (n === 1 ? 'este kit' : 'estes kits') : 'os primeiros kits da lista') + ', e confere pelo chassi.' })
      + caixaRespostas(lista) + notaMotor + notaSintoma(lista)
      + (visAcima.length ? api.grade(visAcima, 0) : '')
      + (visAbaixo.length ? '<p class="r130-kits__divisor">' + esc(visAcima.length ? 'Com outro motor na aplicação cadastrada: confirme pelo chassi'
        : 'Nenhum kit desta lista cita o motor ' + nomeMotor + ' na aplicação: confirme pelo chassi') + '</p>'
        + '<div data-kguia-outro-motor>' + api.grade(visAbaixo, visAcima.length) + '</div>' : '');
    if (n > vis.length) h += '<div class="r130-kits__mais"><button type="button" class="r130-btn r130-btn--ghost" data-kguia="mais">Mostrar mais '
      + plural(Math.min(POR_PAGINA, n - vis.length), 'kit', 'kits') + ' (de ' + (n - vis.length) + ')</button></div>';
    h += '<div class="r130-kits-guia__fim"><h3 class="r130-kits-guia__fim-h3">Não é nenhum destes?</h3>'
      + '<p>Mande as suas respostas para um vendedor: ele recebe o carro, o que você respondeu e os kits desta lista, e confere pelo chassi.</p>'
      + blocoWhats({ lista: lista, itens: itens, c: c, contexto: 'resultado', passo: 'resultado_fim', texto: 'Falar com um vendedor',
        legenda: 'Ele descobre pelo chassi o que falta.' }) + '</div>'
      + api.dataLista() + '</div>';
    api.painel.innerHTML = h;
    // Em cada cartão de outro motor, o aviso âmbar do localizador ("Confirme pelo chassi") com o motor da aplicação.
    var cardsAbaixo = api.painel.querySelectorAll('[data-kguia-outro-motor] .r130-kits__card');
    visAbaixo.forEach(function (x, i) {
      var card = cardsAbaixo[i], fit = card && card.querySelector('.r130-kits__fit');
      if (x.motor && x.motor.outro) return;   // o cartão do localizador já avisa o motor do Meu carro (agente veiculo-motor)
      var ms = N.perfil(x, c.a, cfg).motores || [];
      if (fit) fit.insertAdjacentHTML('afterend', '<p class="r130-kits__fit r130-kits__fit--chassi r130-kits-guia__motor">' + ico('alerta')
        + '<span><strong>Confirme pelo chassi.</strong> A aplicação cadastrada cita ' + (ms.length === 1 ? 'o motor ' : 'os motores ')
        + esc(ms.join(', ')) + '; o seu é ' + esc(nomeMotor) + '.</span></p>');
    });
    telaAtual = { tela: 'resultado', n: n, lista: lista, r: r, itens: itens };
    msgDoPainel(mensagem(lista, itens, c, 'confirmar'));
    var chaveRes = N.escrever(lista) + '|' + (r.ver ? 'ver' : '');
    if (!sessao.resultados[chaveRes]) {
      sessao.resultados[chaveRes] = 1;
      sessao.concluiu = true;
      emitir('kit_guia_resultado', Object.assign(camposCarro(), camposSessao(), { kits: n, total: total, em_estoque: est, com_anuncio: site,
        perguntas: lista.filter(function (x) { return !x.auto; }).length,
        nao_sei: lista.filter(function (x) { return x.v === N.NAO_SEI; }).length,
        via: via, motor_meu_carro: lista.some(function (x) { return x.auto; }), motor_abaixo: abaixo.length }));
    }
  }

  function mensagem(lista, itens, c, contexto) {
    var l = [];
    l.push(contexto === 'resultado' ? 'Olá! Respondi as perguntas do site (Kits por carro) e não achei o kit certo.'
      : contexto === 'confirmar' ? 'Olá! Respondi as perguntas do site (Kits por carro) e quero confirmar estes kits para o meu carro.'
      : 'Olá! Estou nas perguntas do site (Kits por carro) e quero ajuda para achar o kit.');
    l.push('Meu carro: ' + nomeCarro(c, true));
    var m = motorConhecido(lista);
    l.push('Motor:' + (m ? ' ' + m : ''));
    var resp = lista.filter(function (x) { return x.q !== 'motor' && !x.ignorada; });
    if (resp.length) {
      l.push('O que respondi:');
      resp.forEach(function (x) { l.push('- ' + (ROTULO[x.q] || x.q) + ': ' + textoResposta(x)); });
    } else l.push('Ainda não respondi as perguntas.');
    var k = Math.min(5, itens.length);
    if (k) {
      l.push(itens.length > k ? 'Os ' + k + ' primeiros dos ' + itens.length + ' kits que combinam:' : k === 1 ? 'O kit que combina:' : 'Os ' + k + ' kits que combinam:');
      var mm = N.motorDe(lista);
      itens.slice(0, k).forEach(function (x) {
        l.push('- ' + x.k.n + ' (' + x.k.id + ')' + (mm && !N.bateMotor(N.perfil(x, c.a, cfg), mm) ? ', aplicação com outro motor' : ''));
      });
    }
    l.push('Chassi:');
    return l.join('\n');
  }
  function linhaChassi() {
    var v = lsJson('r130_chassi'), vin = v && v.vin ? String(v.vin) : '';
    return vin ? 'O chassi salvo neste aparelho (final ' + esc(vin.slice(-6)) + ') entra sozinho na última linha.'
      : 'Sem chassi salvo: escreva o chassi na última linha ou <a href="https://wa.me/' + FONE + '" data-r130-chassi-abrir>salve o chassi neste aparelho</a>.';
  }
  function telaWhats(calc, r, lista, c) {
    var itens = N.ordenar(calc.itens, lista, cfg, c.a);
    var contexto = r.waCtx || (r.ver || !N.proxima(calc.itens, lista, cfg, c.a) ? 'resultado' : 'vendedor');
    var msg = mensagem(lista, itens, c, contexto);
    var h = '<div class="r130-kits-guia" data-kguia-tela="whatsapp">'
      + '<button type="button" class="r130-kits__voltar" data-kguia="voltar-wa">' + ico('voltar') + 'Voltar</button>'
      + '<h2 class="r130-kits__h2" data-kits-foco tabindex="-1">Falar com um vendedor</h2>'
      + '<p class="r130-kits__intro">Esta mensagem vai para o WhatsApp da 130R com o carro, as suas respostas e os kits que combinam. Dá para mudar o texto antes de enviar.</p>'
      + '<div class="r130-kits-guia__wa">'
      + '<label class="r130-kits-guia__wa-rot" for="r130-kguia-msg">Mensagem</label>'
      + '<textarea class="r130-kits-guia__wa-campo" id="r130-kguia-msg" rows="12" maxlength="1500" data-kguia-msg>' + esc(msg) + '</textarea>'
      + '<p class="r130-kits-guia__wa-chassi" data-kguia-chassi>' + linhaChassi() + '</p>'
      + '<a class="r130-btn r130-btn--wa r130-kits-guia__wa-btn" target="_blank" rel="noopener" data-kguia-wa="mensagem" data-kguia-ctx="' + contexto + '" href="' + esc(linkWa(msg)) + '">'
      + ico('whatsapp') + '<span>Enviar pelo WhatsApp</span></a></div></div>';
    api.painel.innerHTML = h;
    telaAtual = { tela: 'whatsapp', n: itens.length, lista: lista, r: r, contexto: contexto, original: msg };
    msgDoPainel(msg);
  }

  function telaSemKit(c) {
    var msg = 'Olá! Não achei no site kit para o meu carro.\nMeu carro: ' + nomeCarro(c, true) + '\nMotor:\nO que preciso:\nChassi:';
    api.painel.innerHTML = '<div class="r130-kits-guia" data-kguia-tela="sem-kit">'
      + '<h2 class="r130-kits__h2" data-kits-foco tabindex="-1">Ainda não temos kit cadastrado para o ' + esc(nomeCarro(c)) + '</h2>'
      + '<div class="r130-kits__vazio"><p>Mande o chassi pelo WhatsApp: a equipe confere as peças e responde se temos o kit, mesmo que ele não esteja na lista.</p>'
      + '<div class="r130-kits__vazio-acoes"><a class="r130-btn r130-btn--wa" target="_blank" rel="noopener" data-kguia-wa="sem_kit" href="' + esc(linkWa(msg)) + '">'
      + ico('whatsapp') + '<span>Pedir o kit pelo WhatsApp</span></a>'
      + '<button type="button" class="r130-btn r130-btn--ghost" data-kits-acao="trocar">Trocar o carro</button></div></div>'
      + '<p class="r130-kits-guia__sair"><button type="button" class="r130-kits__linkbtn" data-kguia="sair">Sair das perguntas</button></p></div>';
    telaAtual = { tela: 'sem-kit', n: 0, lista: [], r: { lista: [] } };
  }

  // Chamado pelo localizador no passo 'guia' (carro já escolhido). Devolve uma Promise.
  function render(A) {
    api = A;
    var e = api.estado(), c = e.carro;
    if (!cfgDe(api.indice())) return Promise.resolve();
    var ent = Date.now() - ultimoPop < 2000 ? 'voltar_navegador' : 'link';
    if (abrirSessao(ent)) emitir('kit_guia_inicio', Object.assign(camposCarro(), { entrada: ent }));
    return api.kitsDoCarro(c).then(function (todos) {
      if (!todos.length) { telaSemKit(c); return; }
      todos.forEach(function (x) { var p = N.perfil(x, c.a, cfg); p.itens.forEach(function (id, i) { mapaItens[id] = p.nomes[i]; }); });
      var r = respostasDaTela(), lista = r.lista;
      var rs = lista.filter(function (x) { return x.q === 'sintoma'; })[0];
      sessao.sintoma = rs ? rs.v : '';
      var calc = N.calcular(todos, lista, cfg, c.a);
      if (r.wa) return telaWhats(calc, r, lista, c);
      var px = r.ver ? null : N.proxima(calc.itens, lista, cfg, c.a);
      if (px) return telaPergunta(px, calc, todos.length, r, lista, c);
      telaResultado(calc, todos.length, r, lista, c, r.ver ? 'ver_agora' : lista.some(function (x) { return !x.auto; }) ? 'automatico' : 'poucos_kits');
    });
  }

  // Linhas curtas para a mensagem do cartão e do "Não achou?" enquanto as perguntas estão abertas.
  function resumoCurto() {
    if (!api || !cfgDe(api.indice())) return '';
    var e = api.estado();
    if (e.guia == null || !e.carro) return '';
    var lista = respostasDaTela().lista;
    var partes = lista.filter(function (x) { return x.q !== 'motor' && x.v !== N.NAO_SEI; }).map(textoResposta);
    var out = partes.length ? 'Pelas perguntas do site: ' + partes.join(' > ') : '';
    var m = motorConhecido(lista);
    return out + (m ? (out ? '\n' : '') + 'Motor: ' + m : '');
  }

  /* ---------- convites (fora das perguntas) ---------- */
  function convite(entrada) {
    return '<div class="r130-kits-guia__convite" data-kguia-convite>'
      + '<span class="r130-kits-guia__convite-ico" aria-hidden="true">' + ico('nota') + '</span>'
      + '<p class="r130-kits-guia__convite-txt"><strong>Não sabe o nome da peça?</strong> Responda algumas perguntas sobre o que está acontecendo com o carro e veja os kits que combinam.</p>'
      + '<button type="button" class="r130-btn r130-btn--ink r130-kits-guia__convite-btn" data-kguia="iniciar" data-entrada="' + entrada + '">Responder as perguntas</button></div>';
  }
  function colocarConvites(passo, guiaAtivo) {
    var p = api && api.painel;
    if (!p || !disponivel(api.indice())) return;
    if (guiaAtivo) {
      if (passo === 'carro' && !p.querySelector('[data-kguia-faixa]')) {
        p.insertAdjacentHTML('afterbegin', '<div class="r130-kits-guia__faixa" data-kguia-faixa><p><strong>Perguntas para achar o kit.</strong> Primeiro o carro; depois vêm algumas perguntas rápidas.</p>'
          + '<button type="button" class="r130-kits__linkbtn" data-kguia="sair">Sair das perguntas</button></div>');
      }
      return;
    }
    if (p.querySelector('[data-kguia-convite]')) return;
    if (passo === 'carro') {
      var depois = p.querySelector('.r130-kits__intro--depois') || p.querySelector('[data-kits-form-carro]');
      if (depois) depois.insertAdjacentHTML('afterend', convite('convite_carro'));
    } else if ((passo === 'parte' || passo === 'tipo') && p.querySelector('.r130-kits__opcoes')) {
      var i = p.querySelector('.r130-kits__intro');
      if (i) i.insertAdjacentHTML('afterend', convite('convite_' + passo));
    }
    var na = p.querySelector('.r130-kits__naoachou-link');
    if (na && !na.querySelector('[data-kguia]')) {
      na.insertAdjacentHTML('beforeend', ' ou <button type="button" class="r130-kits__linkbtn r130-kits-guia__linkna" data-kguia="iniciar" data-entrada="naoachou_' + passo + '">responda algumas perguntas</button>');
    }
    var vazio = p.querySelector('.r130-kits__vazio-acoes');
    if (vazio && passo === 'busca' && !vazio.querySelector('[data-kguia]')) {
      vazio.insertAdjacentHTML('beforeend', '<button type="button" class="r130-btn r130-btn--ghost" data-kguia="iniciar" data-entrada="busca_vazia">Responder algumas perguntas</button>');
    }
  }
  // A busca do localizador ("Ex.: bucha bandeja traseira") some enquanto as perguntas estão abertas: no celular ficavam
  // duas buscas, a do topo do site e a da página (pedido do Marcus, 19/10/2026). Volta ao sair das perguntas.
  function buscaDaPagina(guiaAtivo) {
    var raiz = document.querySelector('[data-r130-kits]');
    var f = raiz && raiz.querySelector('[data-kits-busca]');
    if (f) f.hidden = !!guiaAtivo;
    if (raiz) raiz.classList.toggle('r130-kits-guia-ativo', !!guiaAtivo);
  }
  function secaoNaoAchou(guiaAtivo) {
    var s = document.querySelector('[data-r130-kits-naoachou]');
    if (!s || !api || !disponivel(api.indice())) return;
    var el = s.querySelector('[data-kguia-na]');
    if (!el) {
      var alvo = s.querySelector('.r130-kits-na__texto') || s.querySelector('.r130-wrap');
      if (!alvo) return;
      alvo.insertAdjacentHTML('beforeend', '<p class="r130-kits-guia__na" data-kguia-na>Não sabe o nome da peça? '
        + '<button type="button" class="r130-kits__linkbtn" data-kguia="iniciar" data-entrada="naoachou_secao">Responda algumas perguntas</button>'
        + ' sobre o que está acontecendo e veja os kits que combinam.</p>');
      el = s.querySelector('[data-kguia-na]');
    }
    el.hidden = !!guiaAtivo;
  }

  /* ---------- cliques ---------- */
  function lerTela() { return respostasDaTela(); }
  document.addEventListener('click', function (ev) {
    var t = ev.target && ev.target.closest ? ev.target : null;
    if (!t || !api) return;
    var wa = t.closest('[data-kguia-wa]');
    var cartaoWa = !wa && t.closest('[data-kits-wa]');
    if (cartaoWa && !cartaoWa.closest('[data-kguia-tela]')) cartaoWa = null;   // cartão fora das perguntas: só o evento do localizador
    if (wa || cartaoWa) {
      var campo = document.querySelector('[data-kguia-msg]');
      if (sessao) sessao.concluiu = true;
      var passo = wa ? wa.getAttribute('data-kguia-wa') : 'cartao';
      emitir('kit_guia_whatsapp', Object.assign(camposCarro(), camposSessao(), { passo: passo, via: passo,
        contexto: wa ? wa.getAttribute('data-kguia-ctx') || '' : '', kit: cartaoWa ? cartaoWa.getAttribute('data-kits-wa') : '',
        perguntas: telaAtual ? telaAtual.lista.filter(function (x) { return !x.auto; }).length : 0,
        kits: telaAtual ? telaAtual.n : '', editou: !!(passo === 'mensagem' && campo && telaAtual && campo.value !== telaAtual.original) }));
      return;
    }
    var b = t.closest('[data-kguia]');
    if (!b) return;
    var acao = b.getAttribute('data-kguia');
    ev.preventDefault();
    var r, lista;
    if (acao === 'iniciar') {
      var entrada = b.getAttribute('data-entrada') || 'convite';
      if (abrirSessao(entrada)) emitir('kit_guia_inicio', Object.assign(camposCarro(), { entrada: entrada }));
      comoSair = '';
      mostrar = POR_PAGINA;
      api.ir({ guia: '', s: null, t: null, q: '', todos: false, trocar: false });
      return;
    }
    r = lerTela(); lista = r.lista;
    if (acao === 'responder') {
      var q = b.getAttribute('data-q'), v = b.getAttribute('data-v');
      var antes = telaAtual ? telaAtual.n : '', depois = parseInt(b.getAttribute('data-n'), 10) || antes;
      var extraMotor = q === 'motor' ? { motor_primeiro: v === N.NAO_SEI ? '' : depois } : {};
      if (q === 'motor') depois = antes;   // o motor só ordena: nenhum kit sai da lista
      emitir('kit_guia_pergunta', Object.assign(camposCarro(), camposSessao(), extraMotor, { pergunta: q, resposta: v,
        ordem: lista.filter(function (x) { return !x.auto; }).length + 1, kits_antes: antes, kits: depois }));
      ir(lista.filter(function (x) { return x.q !== q; }).concat([{ q: q, v: v }]));
    } else if (acao === 'voltar') {
      if (r.ver) { ir(lista); return; }
      var feitas = lista.filter(function (x) { return !x.auto; });
      ir(feitas.slice(0, -1));
    } else if (acao === 'ver') ir(lista, ['ver']);
    else if (acao === 'vendedor') {
      var ctx = b.getAttribute('data-ctx') || '';
      ir(lista, (r.ver ? ['ver'] : []).concat([ctx === 'confirmar' ? 'wac' : ctx === 'resultado' ? 'war' : 'wa']));
    }
    else if (acao === 'voltar-wa') ir(lista, r.ver ? ['ver'] : []);
    else if (acao === 'refazer') ir([]);
    else if (acao === 'sair') { comoSair = 'sair'; api.ir({ guia: null, s: null, t: null, q: '', trocar: false }); }
    else if (acao === 'mais') {
      var antesN = api.painel.querySelectorAll('.r130-kits__card').length;
      mostrar += POR_PAGINA;
      render(api).then(function () {
        var cards = api.painel.querySelectorAll('.r130-kits__card');
        if (cards[antesN]) { cards[antesN].setAttribute('tabindex', '-1'); try { cards[antesN].focus({ preventScroll: false }); } catch (e) { cards[antesN].focus(); } }
      });
    }
  });
  document.addEventListener('submit', function (ev) {
    var f = ev.target && ev.target.closest ? ev.target.closest('[data-kguia-codigo]') : null;
    if (!f || !api) return;
    ev.preventDefault();
    var campo = f.querySelector('input'), v = (campo && campo.value || '').trim().slice(0, 80);
    if (!v) { if (campo) campo.focus(); return; }
    // Já tem o código: vai para a busca do localizador. Conta como resposta (não é desistência).
    emitir('kit_guia_pergunta', Object.assign(camposCarro(), camposSessao(), { pergunta: 'codigo', resposta: 'busca', ordem: 1,
      kits_antes: telaAtual ? telaAtual.n : '', kits: '', entrada: sessao ? sessao.entrada : '' }));
    if (sessao) sessao.concluiu = true;
    comoSair = 'busca_codigo';
    var topo = document.getElementById('r130-kits-q');
    if (topo) topo.value = v;
    api.ir({ q: v, todos: false, guia: null, s: null, t: null, trocar: false });
  });
  // Envio pelo painel do chassi (barra do celular) com as perguntas abertas: conta como WhatsApp das perguntas.
  document.addEventListener('submit', function (ev) {
    var dlg = ev.target && ev.target.closest ? ev.target.closest('#r130-chassi') : null;
    if (!dlg || !api || api.estado().guia == null) return;
    if (sessao) sessao.concluiu = true;
    emitir('kit_guia_whatsapp', Object.assign(camposCarro(), camposSessao(), { passo: 'painel_chassi', via: 'painel_chassi',
      perguntas: telaAtual ? telaAtual.lista.filter(function (x) { return !x.auto; }).length : 0, kits: telaAtual ? telaAtual.n : '' }));
  });
  document.addEventListener('input', function (ev) {
    var campo = ev.target && ev.target.closest ? ev.target.closest('[data-kguia-msg]') : null;
    if (!campo) return;
    var a = document.querySelector('[data-kguia-wa]');
    // Atualiza o link a cada letra (o r130-chassi.js põe o chassi no clique; reescrever no clique apagaria o chassi).
    if (a) a.href = linkWa(campo.value);
  });
  document.addEventListener('r130:chassi', function () {
    var p = document.querySelector('[data-kguia-chassi]');
    if (p) p.innerHTML = linhaChassi();
  });

  // Fim de cada passo do localizador: convites, a seção "Não achou?" e o fim de uma ida às perguntas.
  document.addEventListener('r130:kits-passo', function (ev) {
    var d = ev.detail || {};
    if (!api) api = window.R130Kits || null;
    if (!api) return;
    if (!d.guia) { fecharSessao(d.passo); msgDoPainel(null); }
    colocarConvites(d.passo, d.guia);
    secaoNaoAchou(d.guia);
    buscaDaPagina(d.guia);
  });
  window.addEventListener('popstate', function () { ultimoPop = Date.now(); }, true);
  window.addEventListener('pagehide', function () {
    if (sessao && !sessao.fechada && !sessao.concluiu && api && api.estado().guia != null) { comoSair = 'fechou_pagina'; fecharSessao('fechou'); }
  });

  window.R130KitsGuia = { render: render, resumoCurto: resumoCurto, disponivel: disponivel, nucleo: N };

  // O localizador carregou antes deste arquivo e o endereço pede as perguntas: redesenha.
  if (window.R130Kits && window.R130Kits.indice() && window.R130Kits.estado().guia != null && window.R130Kits.redesenhar) {
    window.R130Kits.redesenhar();
  }
})();
